import { withAsyncBoundary } from '@toss/async-boundary';
import { useNextRouter } from '@zep/next';
import { PlanPaymentOnetimeSuccess } from '../../../../components/service/plan-payment';
import { usePlanDetail } from '../../../../services';

/**
 * 결제가 완료된 후 해당 플랜의 계좌 대기중인 상태를 체크해서 대기중이면 결제 대기중 페이지로 이동
 */
const OnetimePaymentsSuccessPageViewInner = () => {
  const {
    query,
    replace
  } = useNextRouter({
    suspense: true
  });
  const spacePlanHashId = (query.spacePlanHashId || '').toString();
  const {
    data: planDetailData
  } = usePlanDetail(spacePlanHashId);
  const isPendingDeposit = planDetailData?.paymentInfo?.virtualAccountInfo != null;
  if (isPendingDeposit) {
    replace(`/plan-payment/onetime/${spacePlanHashId}/pending-deposit`);
    return null;
  }
  return <PlanPaymentOnetimeSuccess data-sentry-element="PlanPaymentOnetimeSuccess" data-sentry-component="OnetimePaymentsSuccessPageViewInner" data-sentry-source-file="OnetimePaymentsSuccessPageView.tsx" />;
};
export const OnetimePaymentsSuccessPageView = withAsyncBoundary(OnetimePaymentsSuccessPageViewInner, {
  pendingFallback: null,
  rejectedFallback: () => null
});